import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../axiosConfig';

export const fetchExpenses = createAsyncThunk('expenses/fetch', async () => {
  const res = await axios.get('/expenses');
  return res.data.expenses; // Extract expenses array from wrapped response
});

export const createExpense = createAsyncThunk('expenses/create', async ({ expense }) => {
  const res = await axios.post('/expenses', expense);
  return res.data.expense; // Extract expense from wrapped response
});

export const updateExpense = createAsyncThunk('expenses/update', async ({ id, expense }) => {
  const res = await axios.put(`/expenses/${id}`, expense);
  return res.data.expense; // Extract updated expense from wrapped response
});

export const deleteExpense = createAsyncThunk('expenses/delete', async (id) => {
  await axios.delete(`/expenses/${id}`);
  return id;
});

const expensesSlice = createSlice({
  name: 'expenses',
  initialState: { items: [], status: 'idle', error: null },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchExpenses.pending, (s) => { s.status = 'loading'; })
     .addCase(fetchExpenses.fulfilled, (s, a) => { s.status = 'succeeded'; s.items = a.payload; })
     .addCase(fetchExpenses.rejected, (s, a) => { s.status = 'failed'; s.error = a.error.message; })
     .addCase(createExpense.fulfilled, (s, a) => { s.items = [a.payload, ...s.items]; })
     .addCase(updateExpense.fulfilled, (s, a) => {
       const index = s.items.findIndex(item => item.id === a.payload.id);
       if (index !== -1) s.items[index] = a.payload;
     })
     .addCase(deleteExpense.fulfilled, (s, a) => {
       s.items = s.items.filter(item => item.id !== a.payload);
     });
  }
});

export default expensesSlice.reducer;
